<app-notification></app-notification>
<!-- Loading -->
<div id="spinner-parent-div" *ngIf="isLoading">
    <div>
        <app-spinner></app-spinner>
        <h2>{{ 'modules.main.loading' | translate }}</h2>
    </div>
</div>
<router-outlet></router-outlet>
